import type { FC } from 'react';

import { Box, Button, Container, IconButton, Typography } from '@mui/material';
import { CloseIcon } from '@truvhq/ui';

import type { UpgradePromoLayoutProps } from './UpgradePromoModal';

export const UpgradePromoBanner: FC<UpgradePromoLayoutProps> = ({ pitch, onCta, onDismiss }) => {
  return (
    <Box
      role="region"
      aria-label="Upgrade plan promotion"
      className="fixed bottom-0 left-0 right-0 z-50 flex h-12 w-full items-center justify-center text-white"
      sx={{
        backgroundImage: 'linear-gradient(90deg, #224185 0%, #254a9e 15%, #203565 50%, #2855bb 70%, #223c79 100%)',
      }}
    >
      <Container disableGutters className="relative h-full px-4" maxWidth="xl">
        <div className="flex h-full w-full items-center justify-center gap-3">
          <Typography className="text-white opacity-90">{pitch.headline}</Typography>
          <Button onClick={onCta} variant="text" size="small" className="text-white underline hover:text-white/80">
            {pitch.ctaLabel}
          </Button>
        </div>
        <IconButton
          aria-label="Dismiss upgrade banner"
          className="absolute right-16 top-1/2 -translate-y-1/2 text-white/80"
          onClick={onDismiss}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </Container>
    </Box>
  );
};
